import { useTranslation } from 'react-i18next';
import { useNavigate, generatePath } from 'react-router-dom';
import { faHandsHoldingHeart } from '@fortawesome/pro-light-svg-icons/faHandsHoldingHeart';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { Button, ButtonType } from '../../../../Button';
import { Storage } from '../../../../../constants';
import { Routes } from '../../../../../Routes';

interface Props {
  city?: string;
  state?: string;
  zip?: string;
}

export const AgencyCareWidget = ({ city = '', state = '', zip = '' }: Props): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = (): void => {
    localStorage.setItem(Storage.AGENCY_CITY, city);
    localStorage.setItem(Storage.AGENCY_STATE, state);
    localStorage.setItem(Storage.AGENCY_ZIP, zip);

    navigate(generatePath(Routes.parent.informationalScreen));
  }

  return (
    <WidgetCard
      iconName={faHandsHoldingHeart}
      iconClasses='text-tansy'
      title={t('dashboard.widgets.agencyCare.title')}
      description={t('dashboard.widgets.agencyCare.description')}
      classes='bg-neutral-100 border-transparent md:w-96 md:min-h-44'
      hasButton
      buttonComponent={
        <Button
          buttonType={ButtonType.primary}
          onClick={handleClick}
        >
          {t('dashboard.widgets.agencyCare.button')}
        </Button>
      }
    />
  );
};
